module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp2_8017.69db85a7.png";